module.exports = __webpack_public_path__ + "static/media/isotipo.9e3eacdf.svg";